var _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWagerIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20Z",
    fill: "url(#paint0_linear_1_14195)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.2647 12.8949C5.35069 12.8089 5.46534 12.7611 5.58954 12.7611H16.7902C16.994 12.7611 17.0959 13.0095 16.9526 13.1528L14.7392 15.3662C14.6532 15.4522 14.5386 15.5 14.4144 15.5H3.21374C3.00992 15.5 2.90801 15.2516 3.05132 15.1082L5.2647 12.8949Z",
    fill: "#EFEFEF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.2647 4.63376C5.35387 4.54777 5.46852 4.5 5.58954 4.5H16.7902C16.994 4.5 17.0959 4.74841 16.9526 4.89172L14.7392 7.10509C14.6532 7.19108 14.5386 7.23885 14.4144 7.23885H3.21374C3.00992 7.23885 2.90801 6.99044 3.05132 6.84713L5.2647 4.63376Z",
    fill: "#EFEFEF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7392 8.73837C14.6532 8.65239 14.5386 8.60462 14.4144 8.60462H3.21374C3.00992 8.60462 2.90801 8.85302 3.05132 8.99633L5.2647 11.2097C5.35069 11.2957 5.46534 11.3435 5.58954 11.3435H16.7902C16.994 11.3435 17.0959 11.0951 16.9526 10.9517L14.7392 8.73837Z",
    fill: "#EFEFEF"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_14195",
    x1: 18.7676,
    y1: 1.06025,
    x2: 2.50869,
    y2: 17.6402,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00FFA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DC1FFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWagerIcon);
export default __webpack_public_path__ + "static/media/wager-icon.b07e48fdd24eb832299f2e2744b21b71.svg";
export { ForwardRef as ReactComponent };